import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCZaUnWezpUXgsJ-5k7nY9umD-ILTlDGBo",
  authDomain: "sky-vault-exchange.firebaseapp.com",
  projectId: "sky-vault-exchange",
  storageBucket: "sky-vault-exchange.appspot.com",
  messagingSenderId: "264707356806",
  appId: "1:264707356806:web:0e5a276b3194b014f13907",
};

// const firebaseConfig = {
//   apiKey: "AIzaSyDtmNsjSnruKS6ZCs3jwqec0QMqGqGKQWk",
//   authDomain: "finance-v2-e1682.firebaseapp.com",
//   projectId: "finance-v2-e1682",
//   storageBucket: "finance-v2-e1682.appspot.com",
//   messagingSenderId: "133386766551",
//   appId: "1:133386766551:web:e0236afa4a4dc881e20892",
// };

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
